import React from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';

export const AvisoLegalCat = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Avís Legal i Condicions d'Ús</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">Titular del lloc web</h2>
          <p className="mb-4">
            Aquest lloc web (en endavant, el "Lloc Web") és propietat d'<strong>Ulysse Julien Berneau</strong>, amb NIE Y5618264E, domicili a Carrer Castillejos 276, SA2A, 08025 Barcelona (Espanya), correu de contacte general info@agencia-ppc.es, telèfon +34 613 076 099 i correu específic per a protecció de dades rgpd@agencia-ppc.es.
          </p>
          <p className="mb-4">
            <strong>Nom comercial:</strong> ArrancaYa BCN i Agència PPC.<br/>
            <strong>Domini principal:</strong> arrancaya-bcn.es agencia-ppc.es
          </p>
        </section>

        <section className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
          <h2 className="text-xl font-semibold mb-3 text-gray-900">Naturalesa del servei: plataforma d'intermediació</h2>
          <p className="mb-3">
            ArrancaYa BCN és una <strong>plataforma d'intermediació i de posada en contacte</strong> que connecta els Usuaris que necessiten un servei d'arrencada de vehicles amb <strong>tècnics i professionals d'assistència independents i homologats</strong> que operen pel seu compte.
          </p>
          <p className="mb-3">
            <strong>Ulysse Julien Berneau és responsable única i exclusivament del lloc web</strong> (el seu contingut, el seu funcionament i la posada en contacte). <strong>No presta directament el servei d'arrencada.</strong> La intervenció física, la seva execució, la qualitat, els terminis i la facturació corresponen íntegrament al tècnic independent que atén cada sol·licitud.
          </p>
          <p>
            En conseqüència, el Titular del lloc web no assumeix cap responsabilitat per la prestació material del servei ni pels danys, retards o incidències derivats de la intervenció dels tècnics independents, que actuen com a únics prestadors i responsables davant l'Usuari.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Objecte i àmbit d'aplicació</h2>
          <p className="mb-4">
            El present Avís legal regula l'accés, navegació i ús del Lloc Web, així com les responsabilitats derivades de la utilització dels seus continguts (entenent per "continguts" els textos, gràfics, logotips, marques, fotografies, programari, codis, dissenys, interfícies, així com qualsevol altra creació protegida), de conformitat amb la normativa espanyola aplicable, en particular la Llei 34/2002, d'11 de juliol, de serveis de la societat de la informació i de comerç electrònic (LSSI), i altra legislació complementària.
          </p>
          <p>
            L'accés o utilització del Lloc Web atribueix la condició d'Usuari i implica l'acceptació plena i sense reserves de totes les disposicions d'aquest Avís legal en la versió publicada en cada moment. Si no estàs d'acord amb els termes aquí exposats, et preguem que t'abstinguis d'usar el Lloc Web.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Condicions d'accés i ús del Lloc Web</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>L'accés al Lloc Web és, amb caràcter general, lliure i gratuït. No obstant això, alguns serveis poden estar subjectes a contractació i al pagament d'un preu conforme a les Condicions de Servei que es publicaran i acceptaran abans de la contractació.</li>
            <li>L'Usuari es compromet a fer un ús diligent, correcte i lícit del Lloc Web i dels seus continguts, i a no utilitzar-los amb fins il·lícits, prohibits o lesius de drets i interessos de tercers, o que de qualsevol manera puguin danyar, inutilitzar, sobrecarregar o deteriorar el Lloc Web o impedir el seu ús normal.</li>
            <li>L'Usuari es compromet a no introduir ni difondre virus informàtics o qualssevol sistemes físics o lògics que siguin susceptibles de provocar danys en els sistemes del Titular o de tercers.</li>
            <li>L'Usuari s'obliga a no emprar identitats falses ni suplantar la identitat d'altres en la utilització del Lloc Web o en la utilització de qualsevol dels seus serveis, incloent el canal de WhatsApp.</li>
            <li>Quan l'Usuari faciliti dades a través de formularis o de WhatsApp, declara que tota la informació subministrada és veraç, exacta, actual i completa. L'Usuari serà l'únic responsable dels danys i perjudicis que pugui ocasionar al Titular o a tercers per facilitar dades falses, inexactes, desactualitzades o incompletes.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">3. Canals de contacte i contractació</h2>
          <p className="mb-4">
            El Lloc Web pot incloure botons o enllaços que permeten iniciar una conversa a través de WhatsApp amb ArrancaYa BCN. WhatsApp és una plataforma de tercers aliena al Titular i es regeix per els seus propis termes i polítiques. En utilitzar aquest canal, l'Usuari accepta les condicions de WhatsApp i entén que certes metadades i continguts del xat poden ser tractats per aquest tercer. El Titular no es responsabilitza del funcionament o disponibilitat de WhatsApp.
          </p>
          <p>
            Certes sol·licituds realitzades per WhatsApp podran requerir l'acceptació prèvia de les Condicions de Servei i de la Política de Privacitat del Titular. En aquests casos, el Titular informarà d'això de forma clara i obtindrà la confirmació expressa de l'Usuari (p. ex., mitjançant un "ACCEPTO/OK" o marcant una casella al formulari de la web) abans de continuar.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">4. Propietat intel·lectual i industrial</h2>
          <p>
            Tots els drets de propietat intel·lectual i industrial sobre el Lloc Web i els seus continguts (incloent, a títol enunciatiu, la marca denominativa o figurativa "ArrancaYa BCN", el logotip, dissenys, textos, imatges, programari, bases de dades, estructura, codis font i objecte, així com el disseny gràfic i el "look & feel") són titulars o llicenciats per Ulysse Julien Berneau i es troben protegits per la legislació nacional i internacional aplicable.
          </p>
          <p className="mt-3">
            Queda prohibida qualsevol forma de reproducció, distribució, comunicació pública, posada a disposició, transformació o explotació dels continguts del Lloc Web, més enllà del que és estrictament necessari per a la navegació i ús del mateix per part de l'Usuari, excepte autorització prèvia i per escrit del Titular. L'ús no autoritzat podrà donar lloc a les responsabilitats legalment establertes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">12. Legislació aplicable i jurisdicció</h2>
          <p className="mb-3">Aquest Avís legal es regeix per la legislació espanyola.</p>
          <ul className="list-disc ml-6 space-y-2">
            <li>Si l'Usuari té la condició de consumidor/usuari, qualsevol controvèrsia se sotmetrà als Jutjats i Tribunals del domicili de l'Usuari o al que resulti imperatiu segons la normativa de consum.</li>
            <li>En cas d'Usuari que no tingui la condició de consumidor (relacions B2B/professionals), les parts se sotmeten, amb renúncia expressa a qualsevol altre fur, als Jutjats i Tribunals de Barcelona capital.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">13. Contacte</h2>
          <p>
            Per a qualsevol consulta relacionada amb el contingut d'aquest Avís legal, pots contactar amb el Titular a info@agencia-ppc.es o al telèfon +34 613 076 099. Per qüestions de privacitat, escriu a rgpd@agencia-ppc.es.
          </p>
        </section>
      </div>
    </div>
  );
};

export const PoliticaPrivacitatCat = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Política de Privacitat</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Responsable del Tractament</h2>
          <p className="mb-4">
            <strong>Responsable:</strong> Ulysse Julien Berneau<br/>
            <strong>NIE:</strong> Y5618264E<br/>
            <strong>Domicili:</strong> Carrer Castillejos 276, SA2A, 08025 Barcelona (Espanya)<br/>
            <strong>Email general:</strong> info@agencia-ppc.es<br/>
            <strong>Email RGPD:</strong> rgpd@agencia-ppc.es<br/>
            <strong>Telèfon:</strong> +34 613 076 099<br/>
            <strong>Noms comercials:</strong> ArrancaYa BCN i Agència PPC
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Dades Personals que Recollim</h2>
          <p className="mb-3">Recollim els següents tipus de dades personals:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Dades d'identificació i contacte:</strong> Nom, telèfon, email, ubicació del servei</li>
            <li><strong>Informació del vehicle:</strong> Marca, model i detalls tècnics necessaris per al servei</li>
            <li><strong>Dades de navegació:</strong> Adreça IP, cookies, informació del dispositiu, pàgines visitades</li>
            <li><strong>Comunicacions WhatsApp:</strong> Missatges, metadades i contingut de les converses per gestió del servei</li>
            <li><strong>Dades de contractació:</strong> Informació necessària per a la prestació del servei i facturació</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">8. Drets de l'Usuari</h2>
          <p className="mb-3">Pot exercir els següents drets:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Accés:</strong> Conèixer quines dades tractem sobre vostè</li>
            <li><strong>Rectificació:</strong> Corregir dades inexactes o incompletes</li>
            <li><strong>Supressió:</strong> Sol·licitar l'eliminació de les seves dades</li>
            <li><strong>Limitació:</strong> Restringir el tractament en certes circumstàncies</li>
            <li><strong>Portabilitat:</strong> Rebre les seves dades en format estructurat</li>
            <li><strong>Oposició:</strong> Oposar-se al tractament basat en interès legítim</li>
            <li><strong>Retirada del consentiment:</strong> En qualsevol moment</li>
          </ul>
          <p className="mt-3">
            Per exercir aquests drets, contacti amb rgpd@agencia-ppc.es. També pot presentar una reclamació davant l'Agència Espanyola de Protecció de Dades (www.aepd.es).
          </p>
        </section>
      </div>
    </div>
  );
};

export const TerminosCondicionesCat = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Condicions Generals de Servei</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="font-medium text-gray-900 mb-2">ArrancaYa BCN – Ulysse Julien Berneau (NIE Y5618264E)</p>
          <p className="text-sm space-y-1">
            <span className="block"><strong>Domicili:</strong> Carrer Castillejos 276, SA2A, 08025 Barcelona (Espanya)</span>
            <span className="block"><strong>Contacte:</strong> info@agencia-ppc.es · +34 613 076 099</span>
            <span className="block"><strong>Privacitat:</strong> rgpd@agencia-ppc.es</span>
            <span className="block"><strong>Domini:</strong> arrancaya-bcn.es</span>
          </p>
        </div>

        <p className="text-sm italic">
          Aquestes Condicions regulen l'ús del lloc web com a plataforma d'intermediació que posa en contacte l'Usuari amb tècnics independents homologats que presten el servei d'arrencada 12 V a domicili a Barcelona (en endavant, el "Servei"). El titular del lloc web actua únicament com a intermediari i no presta directament el Servei. Són complementàries a l'Avís Legal, a la Política de Privacitat i a la Política de Cookies.
        </p>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Objecte del Servei</h2>
          <div className="space-y-3">
            <p><strong>1.1.</strong> ArrancaYa BCN és una plataforma d'intermediació que posa en contacte l'Usuari amb tècnics independents homologats. Són aquests tècnics els qui presten, pel seu compte, l'assistència d'arrencada de vehicles mitjançant equips d'impuls/booster 12 V, el diagnòstic bàsic de bateria i la comprovació de tensió de càrrega amb el motor en marxa. El titular del lloc web no executa, supervisa ni intervé en el Servei.</p>
            <p><strong>1.2.</strong> <strong>Àmbit:</strong> turismes, SUV i furgonetes lleugeres (≤3.500 kg). Vehicles dièsel/gasolina amb sistema de 12 V.</p>
            <p><strong>1.3.</strong> <strong>Exclusions:</strong> no es realitzen remolcs, substitucions de components a la via pública (excepte subministraments puntuals acordats), ni intervencions sobre sistemes d'alt voltatge (vehicles elèctrics/híbrids: només bateria auxiliar 12 V).</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">5. Preus, suplements i impostos</h2>
          <div className="space-y-3">
            <p><strong>5.1.</strong> <strong>Tarifa base orientativa de la xarxa de tècnics</strong> publicada al web (els preus finals els fixen i apliquen els tècnics independents que presten el Servei):</p>
            <ul className="list-disc ml-8 space-y-1">
              <li>Dia (07:30–22:00): 69 € IVA incl.</li>
              <li>Nit / cap de setmana / festius: 89–99 € IVA incl.</li>
            </ul>
            <p><strong>5.3.</strong> <strong>Si no arrenca, és GRATIS:</strong> quan, després de l'actuació conforme al §1 i §4, el vehicle no arribi a arrencar, no es cobra res (0 €).</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">8. Responsabilitat</h2>
          <div className="space-y-3">
            <p><strong>8.1.</strong> El titular del lloc web actua exclusivament com a plataforma d'intermediació. La prestació del Servei, la seva qualitat, seguretat, terminis i resultats són responsabilitat única i exclusiva del tècnic independent que intervé. El titular del lloc web no respon en cap cas dels danys, retards o incidències derivats de la intervenció dels tècnics.</p>
          </div>
        </section>

        <div className="text-center text-sm text-gray-500 bg-gray-50 p-3 rounded">
          <strong>Última actualització:</strong> 17/09/2026
        </div>
      </div>
    </div>
  );
};